// Import necessary libraries
import React from "react";
import ReactDOM from "react-dom";
import App from "./App"; // Your main application component

ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById("root")
);

